export const ALL_POST = "ALL_POST";
export const PIN_POST = "PIN_POST";
export const DELETE_POST = "DELETE_POST";
export const PRE_PIN_POST = "PRE_PIN_POST";
export const PRE_DELETE_POST = "PRE_DELETE_POST";
export const CERT_PIN_POST ="CERT_PIN_POST";
export const CERT_DELETE_POST ="CERT_DELETE_POST";
